import { getProjectPropertySets } from "@/store/project/selector"
import { useSelector } from "react-redux"

export const usePropertySet = () => {
  const propertySets = useSelector(getProjectPropertySets)
  return (name: string) => {
    return propertySets.find(item => item.name === name)
  }
}